export enum CartStatus {
    ACTIVE = 'Active'   
}

export enum UserStatus {
    GUEST = 'guest',
    LOGGEDIN = 'loggedIn'
}